module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_FolderNew_16"],"path":[{"$":{"d":"M9,4H1V2H7Zm7,7.5A4.5,4.5,0,1,1,11.5,7,4.5,4.5,0,0,1,16,11.5ZM14,11H12V9H11v2H9v1h2v2h1V12h2ZM11.5,5.5A6,6,0,0,1,15,6.63V5H1v9H6.05A6,6,0,0,1,11.5,5.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_FolderNew_16.svg
// module id = aGDv
// module chunks = 1